<template>
  <div>
    <el-tree 
    ref="leftTree" 
    node-key="id" 
    :highlight-current="true" 
    :current-node-key="currData.id" 
    size="large"
    :data="projects" 
    @node-click="nodeClick" 
    class="left-tree" 
    :expand-on-click-node="false"
    >
    <template #default="{ data }">
        <span class="custom-tree-node">
          <span v-if="data.type == 'PROJECT'">
            <!-- <el-icon :size="16"><folder-opened /></el-icon> -->
            <!-- {{ data.projectName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #39a3ff;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">项目</span> 
              {{ data.projectName }} 
              <span style="color:#4744ff">&nbsp;&nbsp;[ {{data.userNum|| 0}} ]</span> 
              </span>
          </span>
          <span v-else-if="data.type == 'TEAM'">
            <!-- <el-icon :size="16"><flag /></el-icon> -->
            <!-- {{ data.teamName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #51D351;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">施工队</span> 
              {{ data.teamName }}
              <span style="color:#4744ff">&nbsp;&nbsp;[ {{data.userNum|| 0}} ]</span> 
              </span>
          </span>
          <span v-else-if="data.type == 'GROUP'">
            <!-- <el-icon :size="16"><user-filled /></el-icon> -->
            <!-- {{ data.groupName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #FFA94C;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">班组</span>
              {{ data.groupName }}
              <span style="color:#4744ff">&nbsp;&nbsp;[ {{data.userNum|| 0}} ]</span> 
              </span>
          </span>
        </span>
      </template>
  </el-tree>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { getProjectTreeList} from '@/api/proman/prouser';

export default defineComponent({
  emits: ['project-change'],
  data() {
    return {
      projects: [],
      currData: {}
    }
  },
  props: {
      id: String,
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getProjectTreeList({currentPage: 1, pageSize: 100000,questType:"USERTREE"}).then(({data}) => {
        this.projects = data.data;
       if (this.projects.length) {
          this.currData=this.projects[0]
          if(this.id){
              this.projects.forEach(pro => {
                if(pro.id===this.id){
                  this.currData=pro;
                }
              });
          }
          this.$nextTick(function () {
              this.$refs['leftTree'].setCurrentKey(this.currData.id)
          })
          this.$emit('project-change', this.currData);
        }
        
      });
    },
    clickFirst() {
      this.$refs.leftTree && this.$refs.leftTree.el$.children[0].click()
      console.log('this.$refs.leftTree.el$.children[0]:', this.$refs.leftTree.el$.children[0])
    },
    nodeClick(data) {
      this.currData = data;
      this.$emit('project-change', data);
      this.$nextTick(function () {
          this.$refs['leftTree'].setCurrentKey(this.currData.id)
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.left-tree {
  height: 100%;
  width: 100%;
  overflow: auto;
}
</style>